export const groups = [
  {
    id: 'bindella',
    layout: 'big',
    name: 'Bindella',
    color: '#d38d81',
    title: '<b>Bindella,</b><br/> der Familienbetrieb aus Zürich',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 7,
    volume: '...',
    header_source:
      'Hat 2018 die operative Leitung übernommen: Rudi Bindella jr mit seinem Vater. Foto: Reto Oeschger',
    sort: 2
  },
  {
    id: 'zfv',
    layout: 'big',
    name: 'Zürcher Frauenverein',
    name_short: 'ZFV',
    color: '#444444',
    title: '<b>Zürcher Frauenverein,</b><br/> die Erfahrenen',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 9,
    volume: '60 Millionen Franken',
    header_source:
      'Patrik Scheidegger, COO beim Zürcher Frauenverein, führt die Tabelle in Bern an. Bild: Raphael Moser',
    sort: 1
  },
  {
    id: 'sportgastro',
    layout: 'small',
    name: 'Sportgastro',
    color: '#e8c460',
    title: '<b>Sportgastro,</b><br/> der fleischige Sportsfreund',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 7,
    volume: '...',
    header_source:
      'Sven Rindlisbacher von der Sportgastro eröffnet bald im Bären-Tower. Bild: Nicole Philipp',
    sort: 3
  },

  {
    id: 'gastrokultur',
    layout: 'small',
    name: 'KG Gastrokultur',
    name_short: 'KG Gastrokultur',
    color: '#6d385e',
    title: '<b>KG Gastrokultur,</b><br/> die alternativen Kulturfreunde',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 6,
    volume: '...',
    header_source:
      'Die vier Quereinsteiger von KG Gastrokultur wollen bis zur Pension in der Branche bleiben. Bild: Nicole Philipp ',
    sort: 4
  },
  {
    id: 'taberna',
    layout: 'small',
    name: 'taBerna',
    name_short: 'taBerna',
    color: '#276885',
    title: '<b>taBerna,</b><br/> die Eingesessenen',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 5,
    volume: '...',
    header_source:
      'Von der «Gnagi-Halle» bis zum «Pyri»: Michael Hersberger und Stefan Ruprecht von Taberna Gastro-Kultur. Bild: Raphael Moser',
    sort: 5
  },
  {
    id: 'burkhalter',
    layout: 'big',
    name: 'Burkhalter Gastro',
    name_short: 'Burkhalter',

    color: '#c31f43',
    title: '<b>Burkhalter Gastro,</b><br/> der Traditionelle',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 5,
    volume: '...',
    header_source:
      'Tobias und Nilgün Burkhalter führen für diverse andere Restaurants auch die Buchhaltung. Bild: Nicole Philipp',
    sort: 6
  },
  {
    id: 'raj',
    layout: 'big',
    name: 'Raj',
    color: '#69973f',
    title: '<b>Raj,</b><br/> der Curry-König',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 3,
    volume: '...',
    header_source:
      'Rajkumar Rochemuttu wartete Jahre, bis er weitere Lokale aufmachte. Bild: Manuel Zingg',
    sort: 7
  },
  {
    id: 'badi',
    layout: 'big',
    name: 'Bonsoir',
    name_short: 'Bonsoir',
    color: '#88bde6',
    title: '<b>Bonsoir</b><br/> die Nachteulen',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 4,
    volume: '...',
    header_source:
      'Komplexes Unternehmenskonstrukt: Drei der insgesamt sechs Teilhaber bei der Übernahme der Badibeizen. Bild: Nicole Philipp',
    sort: 8
  },
  {
    id: 'twospice',
    layout: 'small',
    name: 'Two Spice',
    color: '#d87735',
    title: '<b>Two Spice,</b><br/> der Asiate',
    locator: 'https://datawrapper.dwcdn.net/euCh5/3/',
    image: 'placeholder-image-01.jpg',
    count: 3,
    volume: '...',
    header_source: 'Am Sushi-Kaiten sitzen die Berner gern. Bild: zvg',
    sort: 9
  }
]
